export default __webpack_public_path__ + "static/media/scooter.98132988.svg";